import { apiClient, signApiRequest } from ".";
import { useMutation } from "@tanstack/react-query";
import { CustomerCredentials } from "../ui/customerDataStore";
import { captureException } from "@sentry/react";

export const createBooking = async ({
  agentId,
  credentials,
}: {
  // The agent is only known when the customer arrived through a partner link.
  agentId: string | null | undefined;
  credentials: CustomerCredentials;
}) => {
  if (!credentials?.identityId) {
    throw new Error("Missing required user information");
  }

  const userObject = {
    fid: credentials.identityId,
    s: agentId,
  };

  const signedRequest = await signApiRequest(
    "POST",
    `${import.meta.env.VITE_API_URL}/user/booking`,
    credentials,
    { "content-type": "application/json" },
    userObject,
  );

  const response = await apiClient(signedRequest);
  return response.data;
};

export const useCreateBooking = () =>
  useMutation({
    mutationFn: ({
      agentId,
      credentials,
    }: {
      agentId: string | null | undefined;
      credentials: CustomerCredentials;
    }) => {
      return createBooking({
        agentId,
        credentials,
      });
    },
    onSuccess: (data) => {
      return data;
    },
    onError: (error) => {
      captureException(error, {
        tags: {
          operation: "createBooking",
          errorType: error.name || "UnknownError",
        },
        extra: {
          apiEndpoint: "/user/booking",
        },
        level: "error",
      });
    },
  });
